// only display block with class 'show-for-stylist-only' when user is in stylist mode
// add class to block on WP or templates

jQuery('body').ready(showForStylistOnly);
jQuery('window').ready(salonRedirectCheckout);

function showForStylistOnly() {
    const stylistOnlyBlocks = document.querySelectorAll('.show-for-stylist-only');

    if (stylist_mode) {
        for ( const stylistOnlyBlock of stylistOnlyBlocks) {
            stylistOnlyBlock.setAttribute('style', 'display:block');
        }
    }
};

// redirect salon mode users to /orderer-checkout if manually attempt to navigate to /checkout
function salonRedirectCheckout() {
    if (salon_mode && document.URL.indexOf("/checkout/") >= 0) {
        location.href = "/orderer-checkout/";
    }
};
